"use client";

import { readFragment } from "@opensea/graphql";
import { useRef } from "react";
import { SetDropReminderModal } from "@/components/collection/drops/components/SetDropReminderModal";
import { createDropStore } from "@/components/collection/drops/drop-store";
import { CollectionDropContext } from "./CollectionDropContext";
import { CollectionDropProviderCollectionFragment, CollectionDropProviderDropFragment } from "./CollectionDropProvider.fragment";
export function CollectionDropProvider({
  children,
  collection: collectionKey,
  drop: dropKey
}) {
  const collection = readFragment(CollectionDropProviderCollectionFragment, collectionKey);
  const drop = readFragment(CollectionDropProviderDropFragment, dropKey);
  const storeRef = useRef(null);
  if (storeRef.current === null) {
    storeRef.current = createDropStore(collection ?? undefined, drop ?? undefined);
  }
  return <CollectionDropContext.Provider value={storeRef.current}>
      {children}
      {drop ? <SetDropReminderModal drop={drop} /> : null}
    </CollectionDropContext.Provider>;
}